import { useEffect, useState } from "react";
import API from "src/API";

const useMaintenanceBreakData = () => {
  const [data, setData] = useState<IMaintenanceBannerModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await API.MaintenanceBreak.getMaintenanceBreakData();
        const maintenanceData = response?.data?.[0] ?? null;
        setData(maintenanceData);
      } catch (err) {
        console.error("Error fetching maintenance break data:", err);
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
};

export default useMaintenanceBreakData;


// WEBPACK FOOTER //
// ./src/components/MaintenanceBanner/Services/useMaintenanceBreakData.Hook.ts